import _ from 'underscore';

import { DateHelpers } from '../helpers/DateHelpers';
import { IUsageInfo } from '../ServerApi/types/IUsageInfo';

export module MapperHelper {
  export const REST_API_BASE_URL = '/vizportal/api/rest/v1/';


  export function toNumber(value: any): number {

    // Return numbers and null/undefined without conversion
    if (_.isNumber(value) || _.isNull(value) || _.isUndefined(value))
      return value;

    // Otherwise, attempt to parse the value
    return parseInt(value, 10);
  }

  export function toDate(value: string): Date {
    return DateHelpers.fromISOString(value);
  }

  export function toDateFromTimeOffsetObject(value: any): Date {
    if (!value || _.isUndefined(value) || !_.has(value, 'year')) {
      return undefined;
    }

    return new Date(Date.UTC(
      value.year,
      value.monthValue - 1,
      value.dayOfMonth,
      value.hour,
      value.minute,
      value.second
    ));
  }

  export function sortTags(tags: string[]) {
    return _(tags).sortBy((tagName: string) => tagName.toLowerCase());
  }

  export function mapCRASSUsageInfo(content: any): IUsageInfo {
    return {
      favoritesTotal: content.favoritesTotal,
      hitsTotal: content.hitsTotal,
      hitsLastOneMonthTotal: content.hitsLastOneMonthTotal ?? content.hitsSmallSpanTotal,
      hitsLastThreeMonthsTotal: content.hitsLastThreeMonthsTotal ?? content.hitsMediumSpanTotal,
      hitsLastTwelveMonthsTotal: content.hitsLastTwelveMonthsTotal ?? content.hitsLargeSpanTotal
    };
  }
}
